import React, { Component } from 'react';
import Nav from '../common/Nav';
import { Redirect, withRouter } from 'react-router-dom';
import { Grid, Button, Row, Col } from 'react-bootstrap';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { connect } from 'react-redux';
import { load, clearError } from './ducks/actions';
import './style.css';
export class F1095C extends Component {
  componentDidMount() {
    this.props.actions.load();
  }

  render() {
    if (!this.props.token) {
      return <Redirect to="/" />;
    }
    const columns = [
      {
        Header: 'Title',
        accessor: 'title'
      },
      {
        Header: 'Date Issued',
        accessor: 'date_issued',
        Cell: row => {
          var date = new Date(row.value);
          return (
            date.getUTCMonth() +
            1 +
            '-' +
            date.getUTCDate() +
            '-' +
            date.getUTCFullYear()
          );
        }
      },
      {
        Header: '',
        accessor: 'url',
        className: 'text-right',
        Cell: row => (
          <Button bsStyle="primary" onClick={() => window.open(row.value)}>
            Download
          </Button>
        )
      }
    ];
    return (
      <div>
        <Nav />
        <div className="container-fluid fe-main-wrapper">
          <div className="fe-main-content">
            <Grid fluid>
              <Row>
                <Col xs={12}>
                  <h1 className="page-header">1095-C</h1>
                </Col>
              </Row>
              <ReactTable
                data={this.props.data}
                columns={columns}
                className="-striped -highlight"
                defaultPageSize={5}
                NoDataComponent={() => {
                  return null;
                }}
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.paystubReducer.error,
    data: state.paystubReducer.data,
    token: state.loginReducer.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      load: () => {
        dispatch(load());
      },
      clearError: () => {
        dispatch(clearError());
      }
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(F1095C));



// WEBPACK FOOTER //
// ./src/components/F1095C/index.js